import { ADD_NOTIFICATION } from "../constants/paths";
import { axios } from "./axios";
// PUSH NOTIFICATION API
export const pushNotificationApi = async (data) => {
  const response = await axios.post(ADD_NOTIFICATION, data);
  return response?.data;
};
